import { gql } from '@apollo/client';

export const SIGNUP = gql`
  mutation signup($username: String!, $password: String!) {
    signUp(username: $username, password: $password) {
      token
      user {
        _id
      }
    }
  }
`;

export const LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      user {
        _id
      }
    }
  }
`;

export const ADD_POST = gql`
  mutation addPost($body: String!, $latitude: Float!, $longitude: Float!, $nearby: Boolean, $userSolutions: [String]) {
    addPost(body: $body, latitude: $latitude, longitude: $longitude, nearby: $nearby, userSolutions: $userSolutions) {
      body
      latitude
      longitude
      createdAt
      nearby
    }
  }
`;

export const ADD_COMMENT = gql`
  mutation addComment($postId: ID!, $body: String!) {
    addComment(postId: $postId, body: $body) {
      postId
      body
    }
  }
`;

export const DELETE_COMMENT = gql`
  mutation deleteComment($postId: ID!, $commentId: ID!) {
    deleteComment(postId: $postId, commentId: $commentId) {
      _id
    }
  }
`;

export const DELETE_POST = gql`
  mutation deletePost($userId: ID!, $postId: ID!) {
    deletePost(userId: $userId, postId: $postId) {
      user {
          _id
      }
      _id
    }
  }
`;

export const UPDATE_POST = gql`
  mutation updatePost($userId: ID!, $postId: ID!, $body: String!, $userSolutions: [String]) {
    updatePost(userId: $userId, postId: $postId, body: $body, userSolutions: $userSolutions) {
      user {
          _id
      }
      _id
    }
  }
`;


export const UPVOTE_SOLUTION = gql`
  mutation upVoteSolution($postId: ID!, $solutionId: ID!) {
    upVoteSolution(postId: $postId, solutionId: $solutionId) {
      _id
      solution
      upVotes
      downVotes
      rankedVotes {
        userId
        rank
      }
    }
  }
`;

export const DOWNVOTE_SOLUTION = gql`
  mutation downVoteSolution($postId: ID!, $solutionId: ID!) {
    downVoteSolution(postId: $postId, solutionId: $solutionId) {
      _id
      solution
      upVotes
      downVotes
      rankedVotes {
        userId
        rank
      }
    }
  }
`;

export const RANK_SOLUTION = gql`
  mutation rankSolution($postId: ID!, $solutionId: ID!, $rank: Int) {
    rankSolution(postId: $postId, solutionId: $solutionId, rank: $rank) {
      _id
      solution
      upVotes
      downVotes
      rankedVotes {
        userId
        rank
      }
    }
  }
`;

export const UPDATE_USER_IDME = gql`
  mutation updateUserIdme($idmeData: IdmeInput!) {
  updateUserIdme(idmeData: $idmeData) {
    idme {
      uuid
      status {
        group
        subgroups
        verified
      }
    }
  }
}
`;

export const UPDATE_USER_COLOR = gql`
  mutation updateUserColor($color: String!) {
    updateUserColor(color: $color) {
      iconColor
    }
  }
`;

export const GET_ME = gql`
  query GetMe {
    me {
      _id
      username
      iconColor
      idme {
        uuid
        status {
          group
          subgroups
          verified
        }
      }
    }
  }
`;
